import api from '../../utils/api';

export type BlogDashboardStats = {
  total: number;
  published: number;
  draft: number;
  pendingApproval: number;
};

export const fetchBlogDashboardStats = async (): Promise<BlogDashboardStats> => {
  const response = await api.get('/master-admin/dashboard/blog-stats');
  const data = response.data || {};
  return {
    total: Number(data.total ?? 0),
    published: Number(data.published ?? 0),
    draft: Number(data.draft ?? 0),
    pendingApproval: Number(data.pendingApproval ?? 0),
  };
};
